(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-b2b"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!window.__labReportAutoOpen) {
  window.__labReportAutoOpen = true;
  const openLabReport = () => {
    if (window.location.hash !== '#lab-report') return;
    const details = document.querySelector('[data-lab-report-accordion]');
    if (!details) return;
    details.open = true;
    details.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openLabReport);
  } else {
    openLabReport();
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-hero-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.story-hero-video__media--has-video').forEach(function (media) {
  if (media.dataset.autoplayInit === 'true') return;
  media.dataset.autoplayInit = 'true';

  var poster = media.querySelector('.story-hero-video__poster');
  var playBtn = media.querySelector('.story-hero-video__play');
  var player = media.querySelector('.story-hero-video__player');
  if (!poster || !player) return;

  var started = false;

  function startPlayback() {
    if (started) return;
    started = true;

    // Deferred embeds (mp4/YouTube/Vimeo) only get a real src once requested.
    player.querySelectorAll('[data-src]').forEach(function (el) {
      el.src = el.getAttribute('data-src');
      el.removeAttribute('data-src');
    });

    player.hidden = false;
    var vid = player.querySelector('video');
    if (!vid) {
      poster.style.display = 'none';
      return;
    }

    // Wait for the 'playing' event, not play()'s own promise: the promise
    // resolves as soon as playback is requested and not blocked, which (with
    // preload:'none' and nothing buffered yet) can be before the browser has
    // decoded a real frame. Hiding the poster right then showed whatever the
    // video's unbuffered opening frame looked like — soft, blocky, sometimes
    // a completely different early shot than the poster's own thumbnail.
    // 'playing' only fires once actual frames are rendering.
    vid.addEventListener(
      'playing',
      function () {
        poster.style.opacity = '0';
        // The poster has z-index:1 so it paints above the player (which has
        // no z-index at all) even once invisible — without this it keeps
        // intercepting every click meant for the video underneath,
        // including its native play/pause/volume controls.
        poster.style.pointerEvents = 'none';
      },
      { once: true }
    );

    var playPromise = vid.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.catch(function () {
        // Autoplay blocked (e.g. data saver mode) — fall back to the play button.
        player.hidden = true;
        started = false;
      });
    }
  }

  if (playBtn) playBtn.addEventListener('click', startPlayback);

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startPlayback();
            observer.unobserve(media);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    observer.observe(media);
  } else {
    startPlayback();
  }
});

// In-page CTA links (e.g. "See Our Lab Results") scroll to their target
// instead of jumping — matches the pattern in article-table-of-contents.liquid.
document.querySelectorAll('.story-hero-video__cta a[href^="#"]').forEach(function (link) {
  link.addEventListener('click', function (e) {
    var id = this.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var offset = 100;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-image-with-text"] && !Shopify.designMode) return;
  try {
    
if (!window.__labModalBound) {
  window.__labModalBound = true;
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-lab-modal-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-lab-modal-open'));
      if (dialog) {
        dialog.showModal();
        // Same convention as Dawn's own <modal-dialog> (see ModalDialog.show()
        // in global.js) — locks the page behind the dialog so its own
        // scrollbar can't move while the popup is open.
        document.body.classList.add('overflow-hidden');
      }
      return;
    }
    const dialog = event.target.closest('dialog.lab-modal');
    if (dialog && (event.target.closest('[data-lab-modal-close]') || event.target === dialog)) {
      dialog.close();
    }
  });

  // The native `close` event covers every way a <dialog> can close — the
  // click handler above, but also the Esc key, which showModal() handles
  // natively and the click handler never sees. Bound per-dialog rather than
  // delegated on document, since `close` does not bubble.
  document.querySelectorAll('dialog.lab-modal').forEach((dialog) => {
    dialog.addEventListener('close', () => {
      document.body.classList.remove('overflow-hidden');
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
